module.exports = "/_next/static/images/9166a42ab3eda47e60fe01ece36e7cf8-bars-lg.jpg.webp";